import * as React from "react";

import { PortableText, PortableTextProps } from "@portabletext/react";

import { BodyTextVariant } from "cms/theme/theme";
import { Container, LinkWrapper } from "./RichText.styles";

const components: PortableTextProps["components"] = {
  marks: {
    internalLink: ({ value, children }) => (
      <LinkWrapper>
        <a href={value.reference?.slug}>{children}</a>
      </LinkWrapper>
    ),

    link: ({ value, children }) => {
      const { blank, href } = value;

      return blank ? (
        <LinkWrapper>
          <a href={href} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        </LinkWrapper>
      ) : (
        <LinkWrapper>
          <a href={href}>{children}</a>
        </LinkWrapper>
      );
    },
  },
};

export interface RichTextProps {
  text: Queries.Maybe<Record<string, unknown>>;
  variant?: BodyTextVariant;
  noStyle?: boolean;
}

const RichText: React.FC<RichTextProps> = ({
  text,
  variant = "B1",
  noStyle,
}) => {
  const portableText = (
    <PortableText
      value={text as PortableTextProps["value"]}
      components={components}
    />
  );

  if (noStyle) return portableText;

  return <Container $variant={variant}>{portableText}</Container>;
};

export default RichText;
